import { Injectable, Inject } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { ImplementDetails, EquipmentDetails, InspectionDetails, ComponentDetails, ImplementHistory, LastInspectionDetailsForImplementModel } from './implement-details';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { AddObservationPointModal, RebuildImplementVM, ImplementCycleDetails, ImplementRebuildCompleteVM, UpdateImplementTargets } from '../add-observation-point/add-observation-point-modal';
import { EquipmentDetailsParams } from '../setup-equipment/setup-equipment.model';
import { InspectionDetailGroupByDate, ImplementForEquipmentDetails, InspectionHistoryDetails, ImplementHistoryVM, SchematicAndObservationPointDetails, ImplementSummaryForEquipmentDetails } from '../equipment-details/equipment-details.model';
import { InductionVM } from '../config-setup-inductionand-sections/config-setup-inductionand-sections';
import { ApiResponse, AssetReportStyleUpdate, GenericIdName, GenericIdNameVM, ImplementsAndModelsVM, ImpTypeOptionalFields, ReportStyles } from '../setup-implement/setup-implement.model';
import { Tuple } from '../../../../app/entities';
import { HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { ComponentImagesHistory } from '../../../shared/components/component-image-history/component-image-history.model';

@Injectable()
export class ImplementDetailsService {
  constructor(private _http: Http) {

  }
  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }
  public returnGETById(id: string): Observable<ImplementDetails> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', id);
    return this._http.get("Api/Implement/ReturnGETById", { search: params }).share().map(
      (response: Response) => <ImplementDetails>response.json()).catch(this.handleError);
  }
  // public returnEquipmentForGET(id: string): Observable<EquipmentDetails> {
  //     let params: URLSearchParams = new URLSearchParams();
  //     params.set('get_auto', id);
  //     return this._http.get("Api/Implement/ReturnEquipmentForGET", { search: params }).share().map(
  //         (response: Response) => <EquipmentDetails>response.json()).catch(this.handleError);
  // }

  public returnEquipmentForGET(id: string): Observable<EquipmentDetailsParams> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', id);
    return this._http.get('Api/Implement/ReturnEquipmentForGET', { search: params }).share().map(
      (response: Response) => <EquipmentDetailsParams>response.json()).catch(this.handleError);
  }

  public GetEquipmentInspectionHistoryForImplement(get_auto: number): Observable<InspectionHistoryDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/GetEquipmentInspectionHistoryForImplement', { search: params }).share().map(
      (response: Response) => <InspectionHistoryDetails[]>response.json()).catch(this.handleError);
  }

  public GetLastInspectionDetailsForImplement(get_auto: number): Observable<LastInspectionDetailsForImplementModel> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/GetLastInspectionDetailsForImplement', { search: params }).share().map(
      (response: Response) => <LastInspectionDetailsForImplementModel>response.json()).catch(this.handleError);
  }

  public GetSchematicsForImplement(get_auto: number): Observable<ImplementForEquipmentDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/GetSchematicsForImplement', { search: params }).share().map(
      (response: Response) => <ImplementForEquipmentDetails[]>response.json()).catch(this.handleError);
  }

  // public GetSchematicsForImplement(get_auto: number): Observable<ImplementForEquipmentDetails[]> {
  //     const params = new HttpParams().set('get_auto', get_auto.toString());

  //     return this._http.get('api/Implement/GetSchematicsForImplement', { params })
  //     .share().map(
  //         (response: Response) => <ImplementForEquipmentDetails[]>response.json()).catch(this.handleError);
  //     //   .pipe(
  //     //     map((response: any) => response as ImplementForEquipmentDetails[]),
  //     //     catchError(this.handleError)
  //     //   );
  //   }
  public getSchematicsImagesForImplement(get_auto: number): Observable<ImplementForEquipmentDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/GetSchematicsImagesForImplement', { search: params }).share().map(
      (response: Response) => <ImplementForEquipmentDetails[]>response.json()).catch(this.handleError);
  }

  public GetSchematicsImagesAndObsPointsForImplement(get_auto: number): Observable<SchematicAndObservationPointDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/GetSchematicsImagesAndObsPointsForImplement', { search: params }).share().map(
      (response: Response) => <SchematicAndObservationPointDetails[]>response.json()).catch(this.handleError);
  }

  public GetSchematicsImageAndObsPointsForImplement(get_auto: number, schematicId: number, displayCritical: boolean, displayNonCritical: boolean, displayGET: boolean): Observable<SchematicAndObservationPointDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    params.set('SchematicId', schematicId.toString());
    params.set('DisplayCritical', displayCritical.toString());
    params.set('DisplayNonCritical', displayNonCritical.toString());
    params.set('DisplayGET', displayGET.toString());
    return this._http.get('api/Implement/GetSchematicsImageAndObsPointsForImplement', { search: params }).share().map(
      (response: Response) => <SchematicAndObservationPointDetails[]>response.json()).catch(this.handleError);
  }

  public GetSchematicsImageIdsForImplement(get_auto: number): Observable<SchematicAndObservationPointDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/GetSchematicsImageIdsForImplement', { search: params }).share().map(
      (response: Response) => <SchematicAndObservationPointDetails[]>response.json()).catch(this.handleError);
  }

  public GetImplementSchematicsAndObservationPointsHeaderData(get_auto: number): Observable<ImplementSummaryForEquipmentDetails> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/GetImplementSchematicsAndObservationPointsHeaderData', { search: params }).share().map(
      (response: Response) => <ImplementSummaryForEquipmentDetails>response.json()).catch(this.handleError);
  }

  public getSchematicImageBaseString(schematicId: number): Observable<string> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('SchematicId', schematicId.toString());
    return this._http.get('api/Implement/GetSchematicImageBaseString', { search: params }).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }

  public getSchematicsObservationPointsDetails(get_auto: number, SchematicId: number): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    params.set('SchematicId', SchematicId.toString());
    return this._http.get('api/Implement/GetSchematicsObservationPointsDetails', { search: params }).share().map(
      (response: Response) => <any>response.json()).catch(this.handleError);
  }

  public CheckCrackForObsPoints(get_auto: number): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/CheckCrackForObsPoints', { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public returnInspectionDetailsForGET(id: string): Observable<InspectionDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', id);
    return this._http.get("Api/GETInspection/ReturnInspectionDetailsForGET", { search: params }).share().map(
      (response: Response) => <InspectionDetails[]>response.json()).catch(this.handleError);
  }
  public returnComponentsForGET(id: string): Observable<ComponentDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', id);
    return this._http.get("Api/GETComponent/ReturnComponentsForGET", { search: params }).share().map(
      (response: Response) => <ComponentDetails[]>response.json()).catch(this.handleError);
  }
  public returnHistoryForGET(id: string): Observable<ImplementHistory[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', id);
    return this._http.get("Api/GETInspection/ReturnHistoryForGET", { search: params }).share().map(
      (response: Response) => <ImplementHistory[]>response.json()).catch(this.handleError);
  }

  public SaveObservationPoint(params: AddObservationPointModal) {
    return this._http.post('api/Implement/storeObservationPoint', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }
  public storeObservationPointDFI(params: AddObservationPointModal) {
    return this._http.post('api/Implement/storeObservationPointDFI', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }
  public RebuildImplement(data: RebuildImplementVM): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementId', data.ImplementId.toString());
    params.set('Status', data.Status.toString());
    params.set('WorkshopId', data.WorkshopId.toString());
    params.set('cost', data.cost.toString());
    params.set('RebuilStartDate', data.RebuilStartDate.toDateString());
    params.set('comment', data.comment.toString());
    params.set('jobsiteID', data.jobsiteID.toString());
    return this._http.get("Api/Implement/PerformRebuildImplement", { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public GetCurrentCycleDetails(ImplementId: number): Observable<ImplementCycleDetails> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementId', ImplementId.toString());
    return this._http.get('api/Implement/GetCycleDetialsForImplement', { search: params }).share().map(
      (response: Response) => <ImplementCycleDetails>response.json()).catch(this.handleError);
  }

  // int ImplementId,  DateTime RebuildEndDate, string comment, int jobsiteID,
  // //         int Hours, int Bcm, int Tons
  public SaveRebuildComplete(data: ImplementRebuildCompleteVM): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementId', data.ImplementId.toString());
    params.set('StartDate', data.StartDate.toDateString());
    params.set('comment', data.comment.toString());
    params.set('jobsiteID', data.jobsiteID.toString());
    params.set('Hours', data.Hours.toString());
    params.set('Bcm', data.BCM.toString());
    params.set('Tons', data.Tons.toString());
    params.set('CycleNo', data.CycleNo.toString());
    return this._http.get("Api/Implement/PerformRebuildCompleteImplement", { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public UpdateImplementTargets(data: UpdateImplementTargets): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementId', data.ImplementId.toString());
    params.set('Hours', data.Hours.toString());
    params.set('Bcm', data.BCM.toString());
    params.set('Tons', data.Tons.toString());
    params.set('CycleNo', data.CycleNo.toString());
    params.set('NewHours', data.NewHours.toString());
    params.set('NewBCM', data.NewBCM.toString());
    params.set('NewTons', data.NewTons.toString());
    params.set('CycleId', data.CycleId.toString());
    return this._http.get("Api/Implement/PerformUpdateImplementTargets", { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }


  public GetImplementHistoryDetails(get_auto: number): Observable<ImplementHistoryVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/GetImplementHistroy', { search: params }).share().map(
      (response: Response) => <ImplementHistoryVM[]>response.json()).catch(this.handleError);
  }

  public GetReplaceComponentName(event_auto: number): Observable<Tuple> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('event_auto', event_auto.toString());
    return this._http.get('api/Implement/GetReplaceComponentInfo', { search: params }).share().map(
      (response: Response) => <Tuple>response.json()).catch(this.handleError);
  }

  public GetImplementCycleDetails(get_auto: number): Observable<ImplementCycleDetails[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/GetImplementCycleInfo', { search: params }).share().map(
      (response: Response) => <ImplementCycleDetails[]>response.json()).catch(this.handleError);
  }

  // public GetAssestDetailHistroyInfo(get_auto: number): Observable<ImplementForEquipmentDetails> {
  //     let params: URLSearchParams = new URLSearchParams();
  //     params.set('get_auto', get_auto.toString());
  //     return this._http.get<any>('api/Implement/GetAssestDetailHistroyInfo', { search: params }).share().map(
  //         (response: Response) => <EquipmentDetailsParams>response.json()).catch(this.handleError);
  // }

  public GetAssestDetailHistroyInfo(get_auto: number): Observable<ImplementForEquipmentDetails> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('get_auto', get_auto.toString());
    return this._http.get('api/Implement/GetAssestDetailHistroyInfo', { search: params }).share().map(
      (response: Response) => <ImplementForEquipmentDetails>response.json()).catch(this.handleError);
  }



  public GetImplementTypes(): Observable<GenericIdName[]> {
    return this._http.get('api/Implement/GetImplementTypes').share().map(
      (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  }
  public GetSelectedImplementTypes(getSelecedType: number): Observable<GenericIdName[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('implementTypeId', getSelecedType.toString());
    return this._http.get('api/Implement/GetSelectedImplementTypes', { search: params }).share().map(
      (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  }

  public GetAllGETModels(): Observable<GenericIdName[]> {
    return this._http.get('api/Implement/GetAllGETModels').share().map(
      (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  }

  public GetAllGETTypes(): Observable<GenericIdName[]> {
    return this._http.get('api/Implement/GetAllGETTypes').share().map(
      (response: Response) => <GenericIdName[]>response.json()).catch(this.handleError);
  }

public LoadGETReportStyle(): Observable<ReportStyles[]> {
    return this._http.get('api/Implement/GetReportStyles').share().map(
      (response: Response) => <ReportStyles[]>response.json()).catch(this.handleError);
  }

  public GETImplmentModels(selectTypeId: number): Observable<ImplementsAndModelsVM[]> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('GETTypeId', selectTypeId.toString());

    return this._http.get('api/Implement/GETImplmentModels', { search: params }).share().map(
      (response: Response) => <ImplementsAndModelsVM[]>response.json()).catch(this.handleError);
  }


  public GETOptionalFieldsForImplemetType(implementTypeId: number): Observable<ImpTypeOptionalFields> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('implementTypeId', implementTypeId.toString());

    return this._http.get('api/Implement/GETOptionalFieldsForImplemetType', { search: params }).share().map(
      (response: Response) => <ImpTypeOptionalFields>response.json()).catch(this.handleError);
  }


  public UpdateOptionalDatFieldsImplementTpe(searchFields: ImpTypeOptionalFields): Observable<boolean> {
    return this._http.post("api/Implement/UpdateOptionalDatFieldsImplementTpe", searchFields).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public AddNewImplementModel(implementTypeId: number, modelId: number): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('implementTypeId', implementTypeId.toString());
    params.set('modelId', modelId.toString());

    return this._http.get('api/Implement/AddNewImplementModel', { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }


  public addNewGETImplementBuiltNo(modelName: string, implementTypeId: number): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('modelName', modelName);
    params.set('implementTypeId', implementTypeId.toString());
    return this._http.get("Api/Implement/addNewGETImplementBuiltNo", { search: params }).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public addNewImplement(selectTypeId: number, selectedDispalyImpType_: string,
    inputModelName: string): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('gettypeId', selectTypeId.toString());
    params.set('assetDefinationName', selectedDispalyImpType_.toString());
    params.set('modelName', inputModelName.toString());
    return this._http.get("Api/Implement/addImplementation", { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }
  public updateAssetDefination(ImplementTypeId: number, ImpTypeName: string): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementTypeId', ImplementTypeId.toString());
    params.set('ImpTypeName', ImpTypeName.toString());
    return this._http.get("Api/Implement/updateAssetDefination", { search: params }).share().map(
      (response: Response) => <any>response.json()).catch(this.handleError);
  }
  public updateModelName(ImplementTypeId: number, modelName: string, ImpementId: string): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ImplementTypeId', ImplementTypeId.toString());
    params.set('modelName', modelName);
    params.set('ImpementId', ImpementId.toString());
    return this._http.get("Api/Implement/updateModelName", { search: params }).share().map(
      (response: Response) => <any>response.json()).catch(this.handleError);
  }


  public VerifyBuiltaNo(modelName: string): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('modelName', modelName);
    return this._http.get("Api/Implement/VerifyBuiltaNo", { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }

  public updateMaintenanceCost(ActionId: number, MaintenanceCost: number): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ActionId', ActionId.toString());
    params.set('Cost', MaintenanceCost.toString());
    return this._http.get("Api/Implement/UpdateMaintenanceCost", { search: params }).share().map(
      (response: Response) => <any>response.json()).catch(this.handleError);
  }

  public updateCapitalCost(ActionId: number, CapitalCost: number): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('ActionId', ActionId.toString());
    params.set('Cost', CapitalCost.toString());
    return this._http.get("Api/Implement/UpdateCapitalCost", { search: params }).share().map(
      (response: Response) => <any>response.json()).catch(this.handleError);
  }

  public updateBCM(EQBCMTonId: number, equipmentId: number, Cost: number): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('EQBCMTonId', EQBCMTonId.toString());
    params.set('EquipmentId', equipmentId.toString());
    params.set('Cost', Cost.toString());
    return this._http.get("Api/Implement/UpdateBCM", { search: params }).share().map(
      (response: Response) => <any>response.json()).catch(this.handleError);
  }

  public updateTons(EQBCMTonId: number, equipmentId: number, Cost: number): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('EQBCMTonId', EQBCMTonId.toString());
    params.set('EquipmentId', equipmentId.toString());
    params.set('Cost', Cost.toString());
    return this._http.get("Api/Implement/UpdateTons", { search: params }).share().map(
      (response: Response) => <any>response.json()).catch(this.handleError);
  }

  public recalculateImplementAndComponentsLife(get_auto: number): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('GetAuto', get_auto.toString());
    return this._http.get('api/Implement/recalculateImplementAndComponentsLife', { search: params }).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public checkAndRecalculateImplementAndComponentsLife(get_auto: number, eventDate: Date): Observable<number> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('GetAuto', get_auto.toString());
    params.set('EventDate', eventDate.toISOString());
    console.log("params", params);
    return this._http.get('api/Implement/checkAndRecalculateImplementAndComponentsLife', { search: params }).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  public singlePointCrackEntryHandler(GETAuto: number, flagValue: boolean): Observable<boolean> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('GETAuto', GETAuto.toString());
    params.set('FlagValue', flagValue.toString());
    return this._http.get('Api/Implement/SinglePointCrackEntryHandler', { search: params }).share().map(
      (response: Response) => <boolean>response.json()).catch(this.handleError);
  }


  public UpdateGETAssetReportStyle(implementId:number,reportId:number): Observable<number> {
  let obj: AssetReportStyleUpdate = new AssetReportStyleUpdate();
 
  obj.ImplementId=implementId,
  obj.ReportId=reportId
 

    return this._http.post("api/Implement/UpdateGetAssetReportStyle", obj).share().map(
      (response: Response) => <number>response.json()).catch(this.handleError);
  }

  getFilteredGETType(customerId: number[], jobsiteId: number[]): Observable<ApiResponse<GenericIdNameVM[]>> {
    const params = new URLSearchParams();
    if (customerId?.length) {
      params.set('CustomerId', customerId.join(','));
    }
    if (jobsiteId?.length) {
      params.set('JobsiteId', jobsiteId.join(','));
    }
    return this._http
      .get("api/Implement/GetFilteredGETType", { search: params })
      .map(res => res.json() as ApiResponse<GenericIdNameVM[]>)
      .catch(this.handleError);
  }

  public GetObsPointImagesHistory(ImplementId: number, ObsPointId: number): Observable<ComponentImagesHistory[]> {
    const params = new URLSearchParams();
    params.set('ImplementId', ImplementId.toString());
    params.set('ObsPointId', ObsPointId.toString());
    return this._http
      .get("api/GETComponent/GetObsPointImagesHistory", { search: params })
      .map(res => res.json() as ComponentImagesHistory[])
      .catch(this.handleError);
  }


}
